// Why no invoice could be attached (2026-10-29), in words for the CSR and
// the admin. The server's invoice render (server/src/services/
// invoice-attachments.js) returns a reason with an empty result:
//   { code: 'order_not_found', erpOrderIds, account, role }
//   { code: 'no_printable_invoice', erpOrderIds, invoiceIds }
//   { code: 'not_same_customer', erpOrderIds }
//   { code: 'out_of_scope', erpOrderIds?, clientCode? }
//   { code: 'trq_off' }
// The reply box's red line, the agent panel's Invoices box and the refusal
// at Send all word it here, so they say the same thing. "OMS API", never
// "TRQ", in what a person reads. Ids and account codes only; never customer
// data.

const list = (ids) => {
  const xs = (Array.isArray(ids) ? ids : []).filter(Boolean).map(String)
  if (xs.length <= 1) return xs[0] ?? ''
  return `${xs.slice(0, -1).join(', ')} and ${xs.at(-1)}`
}

// The role a read used, for "under role 1AW" (Jenn, 2026-10-29: the role
// only, never the account code).
export function invoiceReadAccountLabel({ role = null } = {}) {
  return role ? `role ${role}` : null
}

// One sentence, or a generic one for an unknown or missing reason.
export function invoiceUnavailableText(reason) {
  const code = reason?.code ?? null
  const ids = list(reason?.erpOrderIds)
  const many = (reason?.erpOrderIds ?? []).filter(Boolean).length > 1
  if (code === 'order_not_found') {
    if (!ids) return 'No order is linked to this contact, so there is no invoice to attach.'
    const under = invoiceReadAccountLabel(reason)
    return `Couldn't load ${ids} from the OMS API${under ? ` under ${under}` : ''} or its order search.`
  }
  if (code === 'no_printable_invoice') {
    return ids ? `${ids} ${many ? 'have' : 'has'} no printable invoice yet.` : 'The order has no printable invoice yet.'
  }
  if (code === 'not_same_customer') {
    return ids ? `${ids} ${many ? "aren't" : "isn't"} on this customer's account.` : "The order isn't on this customer's account."
  }
  if (code === 'out_of_scope') {
    const client = reason?.clientCode ? ` (${ids || 'the order'} is a ${reason.clientCode} order)` : ''
    return `An invoice can be attached only for a 1A or AM Website order on email${client}.`
  }
  if (code === 'trq_off') return 'The OMS API is off here, so the invoice cannot be loaded.'
  return 'Could not find a printable invoice for this order.'
}
